import React from 'react';

import { Link, useLocation } from 'react-router-dom'

const LandingGuest = () => {
    const location = useLocation()

    const configs = {
        "client": {
            signupUrl: '/create-account',
            signupText: 'Register',
            headText: 'We are pioneering the future of luxury lifestyle',
            className: 'client flex-grow-1',
        },
        "member": {
            signupUrl: '/member/create-account',
            signupText: 'Become a member',
            headText: 'Be part of our community, grow your network & refine your lifestyle',
            className: 'member flex-grow-1'
        }
    };

    const type = location.pathname === '/member' ? 'member' : 'client'
    const config = configs[type];

    return (
        <main id='landing' className={config.className}>
            <div className="container">
                <h1>{config.headText}</h1>

                <Link className="sign-up" to={config.signupUrl}>
                    <button>{config.signupText}</button>
                </Link>
            </div>
        </main>
    )
}

export default LandingGuest
